import { Component } from '@angular/core';

@Component({
  selector: 'app-accessdenied',
  standalone: true,
  imports: [],
  templateUrl: './accessdenied.component.html',
  styleUrl: './accessdenied.component.css'
})
export class AccessdeniedComponent {

}
